import { REDUCE_PARAMETER } from '../../constants/actions/policy';

export function reduceParameter(payload) {
    return {
        type: REDUCE_PARAMETER,
        payload,
    };
}
